import React from "react";
const Event = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 25 24", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M2.526 21.553h18.948V3.789H2.526v17.764zm1.185-14.21h16.578v-2.37H3.711v2.37zm0 13.025h16.578V8.526H3.711v11.842z",
    transform: "translate(.333)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M8.16 0L8.842 0.682 3.599 6.316 0 3.461 0.583 2.684 3.508 4.985z",
    transform: "translate(.333) translate(7.579 11.368)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    stroke: "currentColor",
    d: "M16.921 3.026H17.921V5.8149999999999995H16.921zM6.816 3.026H7.816V5.8149999999999995H6.816z",
    transform: "translate(.333)"
  }
)));
var Event_default = Event;
export {
  Event_default as default
};
//# sourceMappingURL=Event.js.map
